/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  EDIT_TESTIMONIAL,
  TESTIMONIAL_DETAIL,
  CLENT_USER_BASE_URL,
  CLENT_COMPANY_BASE_URL,
} from "../../constants/api";
import { Image } from "antd";

function EditTestimonial() {
  const { Content } = Layout;
  const { id } = useParams();
  let history = useNavigate();

  const [state, setstate] = useState(null);
  const [loading, setloading] = useState(true);
  const [form] = Form.useForm();
  const [oldUserImage, setOldUserImage] = useState("");
  const [oldCompanyImage, setOldCompanyImage] = useState("");

  const [selectedUserFile, setSelectedUserFile] = useState(null);
  const [selectedUserFileValue, setSelectedUserFileValue] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileValue, setSelectedFileValue] = useState(null);
  const imageExtensions = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/bmp",
  ];

  useLayoutEffect(() => {
    if (state === null) {
      getDetail();
    }
  }, [
    state,
    form.setFieldsValue({
      name: state != null ? state["name"] : "",
      company_name: state != null ? state["company_name"] : "",
      description: state != null ? state["description"] : "",
      link: state != null ? state["description"] : "",
    }),
  ]);

  const getDetail = () => {
    const postData = new FormData();
    postData.append("id", id);
    const successFn = function (data) {
      console.log(data);
      setstate(data["data"]);
      setOldUserImage(
        data["status"] !== false ? data["data"]["user_image"] : ""
      );
      setOldCompanyImage(
        data["status"] !== false ? data["data"]["company_logo"] : ""
      );
      setloading(false);
      console.log(state);
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to get detail");
    };
    postAPI(TESTIMONIAL_DETAIL, postData, successFn, errorFn);
  };

  const onFileChange = (e) => {
    const files = e?.target?.files;
    let filePath = files[0];
    console.log(files);
    if (imageExtensions.includes(filePath?.type)) {
      setSelectedFile({ selectedFile: filePath });
      setSelectedFileValue(filePath.name);
    } else {
      setSelectedFile({});
      displayMessage(ERROR_MSG_TYPE, "not supported images");
    }
  };
  const onUserFileChange = (e) => {
    const files = e?.target?.files;
    let filePath = files[0];
    console.log(files);
    if (imageExtensions.includes(filePath?.type)) {
      setSelectedUserFile({ selectedUserFile: filePath });
      setSelectedUserFileValue(filePath.name);
    } else {
      setSelectedUserFile({});
      displayMessage(ERROR_MSG_TYPE, "not supported images");
    }
  };
  const update = (values) => {
    console.log(values);

    const data = new FormData();
    data.append("id", state["id"]);
    data.append("name", values.name);
    data.append("company_name", values.company_name);
    data.append("description", values.description);
    data.append("link", values.link);
    if (selectedFile) {
      data.append("company_logo", selectedFile.selectedFile);
    }
    if (selectedUserFile) {
      data.append("user_image", selectedUserFile.selectedUserFile);
    }
    const successFn = function (data) {
      history("/testimonial");
      displayMessage(SUCCESS_MESSAGE, "Data Updated Successfully");
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_TESTIMONIAL, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card loading={loading} title="Edit Category" bordered={false}>
            <Form onFinish={update} form={form} layout="vertical">
              <Form.Item style={{ marginBottom: 0 }}>
                <Row spceber>
                  <Col span={12}>
                    <Form.Item
                      name="name"
                      label="User Name"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Name"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="company_name"
                      label="Comany Name"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Company Name"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Row spceber>
                  <Col span={12}>
                    <Form.Item
                      name="description"
                      label="Testimonial Description"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Description"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="link"
                      label="Testimonial Link"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Link"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Row spceber>
                  <Col span={12}>
                    <Form.Item
                      type="file"
                      name="company_logo"
                      label="Company Image"
                      rules={[{ required: false }]}
                      style={{ marginLeft: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type="file"
                        className="filetype"
                        defaultValue={selectedFileValue}
                        id="myImage"
                        onChange={(e) => onFileChange(e)}
                        name="myImage"
                        placeholder="Company Logo"
                      />
                      <hr />
                      <Image
                        width={100}
                        src={CLENT_COMPANY_BASE_URL + oldCompanyImage}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      type="file"
                      name="user_image"
                      label="User Image"
                      rules={[{ required: false }]}
                      style={{ marginLeft: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type="file"
                        className="filetype"
                        defaultValue={selectedUserFileValue}
                        id="userImage"
                        onChange={(e) => onUserFileChange(e)}
                        name="userImage"
                        placeholder="User Image"
                      />
                      <hr />
                      <Image
                        width={100}
                        src={CLENT_USER_BASE_URL + oldUserImage}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Row>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }} label="" colon={false}>
                    <Button block htmlType="submit">
                      Update Testimonial
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default EditTestimonial;
